import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { advancedSpacing, spacing } from '@vfuk/core-mixins'

import { StyledFooterProps } from './Footer.style.types'

export const Footer = styled.div(
  (props: StyledFooterProps): FlattenSimpleInterpolation => css`
    background-color: ${props.theme.color.monochrome6.default};
    ${advancedSpacing('padding', [4, 6])}
  `,
)

export const FooterContainer = styled.div<StyledFooterProps>(
  (props: StyledFooterProps): FlattenSimpleInterpolation => css`
    max-width: ${props.theme.gridConfig.springWidth}px;
    margin: auto;
  `,
)

export const IconsWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${spacing('margin-bottom', 6)}
  `,
)

export const DividerWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${spacing('margin-bottom', 4)}
  `,
)
